
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

import { UserSlice, createUserSlice } from './store/slices/userSlice';
// createCommunicationSlice removed - slice is empty (notifications managed by React Query)

// Combine Types
// Note: Deprecated slices (PropertySlice, AccountingSlice, MaintenanceSlice, LeasingSlice, WorkflowSlice)
// have been removed as they are empty shells with no state or actions.
// All data management has been migrated to React Query hooks.
// CommunicationSlice interface removed - slice is empty (notifications managed by React Query)
type AppState = UserSlice & {
  resetData: () => void;
};

// Combine Creators
export const useAppStore = create<AppState>()(
  persist(
    (set, get, api) => ({
      ...createUserSlice(set, get, api),

      resetData: () => {
        localStorage.removeItem('hummingbird-storage');
        localStorage.removeItem('hummingbird_db_v9'); // Clear the DB too
        window.location.reload();
      }
    }),
    {
      name: 'hummingbird-storage',
      storage: createJSONStorage(() => localStorage),
      version: 8, // Bump: sessionId added, excluded from persist
      partialize: (s) => ({
        userRole: s.userRole,
        currentUserId: s.currentUserId,
        // sessionId intentionally excluded - not persisted to localStorage
      }),
    }
  )
);
